import { useQuery } from '@tanstack/react-query';
import { fetchStates } from '../services/statesService';

function normalizeStates(data) {
  const states = Array.isArray(data?.states_list) ? data.states_list : [];

  return states
    .filter((state) => state?.state_id)
    .sort((left, right) => {
      const leftPriority =
        (Number(left?.is_user_state) ? -30 : 0) +
        (Number(left?.is_favourite) ? -20 : 0) +
        (Number(left?.is_subscribed) ? -10 : 0) +
        Number(left?.sort_by || 0);
      const rightPriority =
        (Number(right?.is_user_state) ? -30 : 0) +
        (Number(right?.is_favourite) ? -20 : 0) +
        (Number(right?.is_subscribed) ? -10 : 0) +
        Number(right?.sort_by || 0);

      return leftPriority - rightPriority;
    });
}

export function useStates(options = {}) {
  return useQuery({
    queryKey: ['states'],
    queryFn: async () => {
      const data = await fetchStates();

      return {
        title: data?.title || '',
        message: data?.message || '',
        states: normalizeStates(data),
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: options.refetchOnMount ?? true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        title: '',
        message: '',
        states: [],
      },
  });
}
